<nwx-price-summary-display
  [content]="(content$ | async) || {}"
  [protectorContent]="(protectorContent$ | async) || {}"
  [maxSizeMedium]="maxSizeMedium"
  [awaitingProtectorVersionChoice]="awaitingProtectorVersionChoice"
  (addUpsell)="onAddUpsell($event)"
  (showPdf)="onShowPdf()"
></nwx-price-summary-display>
